import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.show("photos")
  }

  select(event) {
    event.preventDefault()
    this.show(event.currentTarget.dataset.postMediaTabsTab)
  }

  show(name) {
    this.tabTargets.forEach((tab) => {
      tab.dataset.active = String(tab.dataset.postMediaTabsTab === name)
    })

    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.postMediaTabsPanel === name
      panel.classList.toggle("hidden", !active)

      if (active) {
        panel.dispatchEvent(new CustomEvent("responsive-gallery:render"))
      }
    })
  }
}
